module.exports = __webpack_public_path__ + "static/media/S1N4-2.f0d1f0d8.svg";